import {Response} from './res.d';
import http from './http';
import constant from './constant';

/* eslint-disable no-magic-numbers */
type QRCodeState = {
    UNUSED: 0;
    SCANED: 1;
    CONFIRMED: 2;
    EXPIRED: 3;
    INEXISTENT: 4;
    UNKNOWN: -1;
}

export const QR_STATE : QRCodeState = {
    UNUSED: 0,
    SCANED: 1,
    CONFIRMED: 2,
    EXPIRED: 3,
    INEXISTENT: 4,
    UNKNOWN: -1,
};

type ValueOf<T extends Record<string, unknown>> = T[keyof T];
export type ValueOfQRCodeState = ValueOf<QRCodeState>;

/** 刷新二维码id */
export const refreshQrId = () => http.get<string, Response<string>>(`${constant.QR_CODE.REFRESH_ID}`);

/**
 * 获取二维码图片文件, 通过img.src引用url实现, 所以只需要返回url
 * @param id 二维码id
 * @return 图片文件url
 */
// export const getQrCodeImgUrl = (id: string) => `http://test-cas.baijiahulian.com${constant.QR_CODE.GET_IMG}?k=${id}`;

/**
 * 获取二维码状态
 * @param id
 */
export const getQrCodeState = (id: string) =>
    http.get<QRCodeState, Response<ValueOfQRCodeState>>(`${constant.QR_CODE.GET_STATE}?k=${id}`);

/**
 * app扫码后确认登录
 * @param id
 */
export const submitLogin = (id: string) => http.get<string, Response<string>>(`${constant.QR_CODE.SUBMIT}?k=${id}`);

/**
 * 切换tab时主动失效二维码
 */
export const cancelQrCode = (id: string) => http.get<string, Response<string>>(`${constant.QR_CODE.CANCEL}?k=${id}`);

